var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { AdminService } from 'app/services/admin.service';
import { AgencyInfoService } from 'app/services/agency-info.service';
import { UserService } from 'app/services/user.service';
import { EditService } from 'app/services/edit.service';
import { ToastrService } from 'ngx-toastr';
var ConfigAgencyProfileComponent = /** @class */ (function () {
    function ConfigAgencyProfileComponent(toastr, agencyInfoService, adminService, editService, userService) {
        this.toastr = toastr;
        this.agencyInfoService = agencyInfoService;
        this.adminService = adminService;
        this.editService = editService;
        this.userService = userService;
        this.info = {
            nguidPattern: {}
        };
        this.givBdryCateList = [];
        this.countyList = [];
    }
    ConfigAgencyProfileComponent.prototype.onChange = function () {
        var _this = this;
        this.hasChanged = !!Object.keys(this.originalInfo).find(function (k) {
            return _this.editService.hasValueChanged(_this.info[k], _this.originalInfo[k]);
            // if (this.info[k] !== this.originalInfo[k]) {
            // 	if (this.info[k] && this.originalInfo[k] && typeof (this.info[k]) === 'object') {
            // 		return JSON.stringify(this.info[k]) !== JSON.stringify(this.originalInfo[k]);
            // 	}
            // }
        });
    };
    ConfigAgencyProfileComponent.prototype.onSelectCounty = function () {
        if (this.info.county) {
            this.info.bdryName = this.info.county.name;
            // this.info.centroidLatlong = this.info.county.centroidStr;
        }
        else {
            this.info.bdryName = '';
            // this.info.centroidLatlong = null;
        }
        this.hasChanged = true;
    };
    ConfigAgencyProfileComponent.prototype.onChangeNeighborCounty = function () {
        this.hasChanged = true;
    };
    ConfigAgencyProfileComponent.prototype.onPatternChange = function (e) {
        this.info.nguidPattern = e;
        this.hasChanged = true;
    };
    ConfigAgencyProfileComponent.prototype.apply = function () {
        return __awaiter(this, void 0, void 0, function () {
            var props_1, keys_1, uniqueKeys, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isApplying = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        props_1 = {};
                        keys_1 = Object.keys(this.originalInfo).concat(Object.keys(this.info));
                        uniqueKeys = keys_1.filter(function (k, idx) { return keys_1.indexOf(k) === idx; });
                        // Filter changed props
                        uniqueKeys.filter(function (k) {
                            if (k === 'county') {
                                if (_this.info.county && _this.originalInfo.county) {
                                    return _this.info.county.name !== _this.originalInfo.county.name;
                                }
                                else {
                                    return !(!_this.info.county && !_this.originalInfo.county);
                                }
                            }
                            else {
                                return _this.editService.hasValueChanged(_this.info[k], _this.originalInfo[k]);
                            }
                        }).forEach(function (k) {
                            switch (k) {
                                case 'shortName':
                                    props_1.customerShortName = _this.info.shortName;
                                    break;
                                case 'longName':
                                    props_1.customerLongName = _this.info.longName;
                                    break;
                                case 'bdryName':
                                    props_1.givBoundaryName = _this.info.bdryName;
                                    break;
                                case 'bdryCate':
                                    props_1.givBoundaryCat = _this.info.bdryCate;
                                    break;
                                case 'county':
                                    props_1.customerCounties = _this.info.county ? [_this.info.county.name] : []; // this.countyList.filter(c => c.isNeighbor).map(c => c.name)
                                    props_1.customerCentroid = _this.info.county.centroidStr;
                                    break;
                                case 'discrepancyAgencyId':
                                    props_1.discripAgId = _this.info.discrepancyAgencyId;
                                    break;
                                case 'nguidPattern':
                                    props_1.customerNguidPattern = _this.info.nguidPattern.layerType ? 2 : 1;
                                    break;
                            }
                        });
                        return [4 /*yield*/, this.adminService.updateCustomer(props_1, this.userService.customerInfo.id)];
                    case 2:
                        _a.sent();
                        this.hasChanged = false;
                        this.toastr.success('Successfully updated.');
                        return [4 /*yield*/, this.userService.getCustomerInfo(null, true)];
                    case 3:
                        _a.sent();
                        this.setInfo();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        this.toastr.error(err_1.message);
                        console.log(err_1);
                        return [3 /*break*/, 5];
                    case 5:
                        this.isApplying = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ConfigAgencyProfileComponent.prototype.setInfo = function () {
        var _this = this;
        this.info = {
            shortName: this.userService.customerInfo.nameShort,
            longName: this.userService.customerInfo.nameLong,
            bdryName: this.userService.customerInfo.bdryName,
            bdryCate: this.userService.customerInfo.bdryCate,
            county: this.countyList.find(function (c) { return c.centroidStr === _this.userService.customerInfo.cusCentroid; }),
            // centroidLatlong: '',
            discrepancyAgencyId: this.userService.customerInfo.discrepancyId,
            nguidPattern: JSON.parse(JSON.stringify(this.userService.customerInfo.nguidPattern))
            // {
            // 	layerType: this.agencyInfoService.getIsLayerTypeFromNguidPattern(this.userService.customerInfo.nguidPattern)
            // }
        };
        this.originalInfo = JSON.parse(JSON.stringify(this.info));
        // this.userService.customerInfo.cusCounties.forEach(c => {
        // 	const county = this.countyList.find(i => i.name === c);
        // 	if (county) {
        // 		county.isNeighbor = true;
        // 	}
        // })
    };
    ConfigAgencyProfileComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.agencyInfoService.getCounties()];
                    case 1:
                        _a.countyList = _b.sent();
                        this.givBdryCateList = this.agencyInfoService.givBdryCateList;
                        this.setInfo();
                        return [2 /*return*/];
                }
            });
        });
    };
    return ConfigAgencyProfileComponent;
}());
export { ConfigAgencyProfileComponent };
